import { Directive } from '@angular/core';

@Directive({
    selector: '[withFooter]',
    standalone: true,
    host: { class: 'with-footer' },
})
export class CardWithFooterDirective
{
}

@Directive({
    selector: '[tableContent]',
    standalone: true,
    host: { class: 'table-content' },
})
export class CardWithTableContentDirective
{
}

@Directive({
    selector: '[nestedCard]',
    standalone: true,
    host: { class: 'nested-card' },
})
export class CardNestedCardDirective
{
}

@Directive({
    selector: '[nestedCardChecklist]',
    standalone: true,
    host: { class: 'nested-card-checklist' },
})
export class CardNestedCardChecklistDirective
{
}
